import * as Yup from 'yup';

export const ReferencesSchema = Yup.object().shape({
  references: Yup.array().of(
    Yup.object().shape({
      typeId: Yup.string().required('Le type de la référence est requis.'),
      value: Yup.string()
        .trim()
        .required('La référence doit avoir une valeur.'),
    }),
  ),
});
